import React, { Fragment, useEffect, useState } from "react";
// Router Links
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import SEOManager from "./SEOManager";
import ScrollToTop from "./ScrollToTop";

// Import styles css
import "../styles/styles.scss";
// Import NPM styles
import "bootstrap-4-react";
import "react-bootstrap";
import "react-icons/fa";
// Import AOS Animation
import AOS from "aos";
import "aos/dist/aos.css";
// Page Links
import HomePage from "./home-component/home-page";
import AboutPage from "./about-component/about-page";
import WhyMarquisPage from "./why-marquis-component/why-marquis-page";
import OurIdentityPage from "./our-identity-component/our-identity-page";
import InvestingPage from "./investing-in-dubai-component/investing-in-dubai-page";
import CollectionPage from "./collection-component/collection-page";
import CollectionInnerPage from "./collection-inner-component/collection-inner-page";
import OurteamPage from "./ourteam-component/ourteam-page";
import MediaPage from "./media-component/media-page";
import BlogPage from "./blog-component/blog-page";
import BlogInnerPage from "./blog-inner-component/blog-inner-page";
import EventsPage from "./events-component/events-page";
import EventsInnerPage from "./events-inner-component/events-inner-page";
import CareerPage from "./career-component/career-page";
import CareerInnerPage from "./career-inner-component/career-inner-page";
import ContactPage from "./contact-component/contact-page";
import BecomeAgentPage from "./become-agent/become-agent-page";
import CommunityPage from "./community-component/community-page";
import InvestorPage from "./investor-relations-component/investor-relations-page";
import PrivacyPage from "./privacy-policy-component/privacy-policy-page";
import TermsConditionsPage from "./terms-conditions-component/terms-conditions-page";
import NotFoundPage from "./404-component/404-page";
import AwardsPage from "./awards-component/awards-page";
import MilestonePage from "./milestone-component/milestone-page";
import ConstructionPage from "./collection-inner-construction/collection-inner-construction-page";
import CommunityInnerPage from "./community-inner-component/community-inner-page";
import BrochureDownload from "./collection-inner-component/BrochureDownload";

import { apiUrl } from "../apiUrl";

// function SEODataFetcher() {
//   const location = useLocation();
//   const [seoData, setSeoData] = useState({ title: "", description: "", canonical: "" });

//   useEffect(() => {
//     const fetchSEOData = async () => {
//       try {
//         const slug = location.pathname === "/" ? "home" : location.pathname.slice(1);
//         const response = await fetch(apiUrl + `/api/seo-meta/${slug}`);
//         const data = await response.json();
//         setSeoData({
//           title: data.title || "Marquis Developers",
//           description: data.description || "Marquis Developers",
//           canonical: data.canonical || "",
//         });
//       } catch (error) {
//         console.error("Error fetching SEO data:", error);
//         setSeoData({
//           title: "Marquis Developers",
//           description: "Marquis Developers",
//           canonical: "",
//         });
//       }
//     };

//     fetchSEOData();
//   }, [location.pathname]);

//   return <SEOManager metaTitle={seoData.title} metaDescription={seoData.description} canonical={seoData.canonical} />;
// }

// function SEODataFetcher() {
//   const location = useLocation();
//   const [seoData, setSeoData] = useState({
//     title: "",
//     description: "",
//     canonical: "",
//   });

//   useEffect(() => {
//     const fetchSEOData = async () => {
//       try {
//         const rawSlug =
//           location.pathname === "/" ? "home" : location.pathname.slice(1);

//         const slug = encodeURIComponent(rawSlug);

//         console.log(rawSlug);

//         const response = await fetch(`${apiUrl}/api/seo-meta/${slug}`);
//         const data = await response.json();

//         setSeoData({
//           title: data.title || "Marquis Developers",
//           description: data.description || "Marquis Developers",
//           canonical:
//             data.canonical || `${window.location.origin}${location.pathname}`,
//         });
//       } catch (error) {
//         console.error("Error fetching SEO data:", error);
//         setSeoData({
//           title: "Marquis Developers",
//           description: "Marquis Developers",
//           canonical: `${window.location.origin}${location.pathname}`,
//         });
//       }
//     };

//     fetchSEOData();
//   }, [location.pathname]);
//   return (
//     <SEOManager
//       metaTitle={seoData.title}
//       metaDescription={seoData.description}
//       canonical={seoData.canonical}
//     />
//   );
// }

// function SEODataFetcher() {
//   const location = useLocation();
//   const [seoData, setSeoData] = useState({
//     title: "",
//     description: "",
//     canonical: "",
//   });

//   useEffect(() => {
//     const fetchSEOData = async () => {
//       try {
//         const rawSlug =
//           location.pathname === "/" ? "home" : location.pathname.slice(1);

//         // console.log(rawSlug);

//         const response = await fetch(
//           `${apiUrl}/api/seo-meta/${rawSlug}`
//         );

//         const data = await response.json();

//         setSeoData({
//           title: data.title || "Marquis Developers",
//           description: data.description || "Marquis Developers",
//           canonical:
//             data.canonical ||
//             `${window.location.origin}${location.pathname}`,
//         });
//       } catch (error) {
//         console.error("Error fetching SEO data:", error);
//         setSeoData({
//           title: "Marquis Developers",
//           description: "Marquis Developers",
//           canonical: `${window.location.origin}${location.pathname}`,
//         });
//       }
//     };

//     fetchSEOData();
//   }, [location.pathname]);

//   return (
//     <SEOManager
//       metaTitle={seoData.title}
//       metaDescription={seoData.description}
//       canonical={seoData.canonical}
//     />
//   );
// }

function SEODataFetcher() {
  const location = useLocation();
  const [seoData, setSeoData] = useState({
    title: "Marquis Developers",
    description: "Marquis Developers",
    canonical: window.location.origin + location.pathname,
  });

  useEffect(() => {
    const fetchSEOData = async () => {
      try {
        const rawSlug = location.pathname === "/" ? "home" : location.pathname.slice(1);

        const response = await fetch(`${apiUrl}/api/seo-meta/${rawSlug}`);
        const data = await response.json();

        // Use backend title & description if available, otherwise fallback
        let title = data.title || "Marquis Developers";
        let description = data.description || "Marquis Developers";

        // Replace any old "Marquis Point" with "Marquis Developers"
        title = title.replace(/Marquis Point/gi, "Marquis Developers");
        description = description.replace(/Marquis Point/gi, "Marquis Developers");

        setSeoData({
          title,
          description,
          canonical: data.canonical || window.location.origin + location.pathname,
        });
      } catch (error) {
        console.error("Error fetching SEO data:", error);
        setSeoData({
          title: "Marquis Developers",
          description: "Marquis Developers",
          canonical: window.location.origin + location.pathname,
        });
      }
    };

    fetchSEOData();
  }, [location.pathname]);

  return (
    <SEOManager
      metaTitle={seoData.title}
      metaDescription={seoData.description}
      canonical={seoData.canonical}
    />
  );
}


function App() {
  useEffect(() => {
    AOS.init({
      duration: "1500",
      once: false,
      // disable: 'mobile'
    });
  }, []);

  return (
    <HelmetProvider>
    <BrowserRouter /*basename={"/marquispoint"} */>
      <ScrollToTop />

      <Fragment>
        <SEODataFetcher />
        <Routes>
          <Route path="/">
            <Route index element={<HomePage />} />
            {/* <Route exact path="/home" element={<HomePage />} /> */}
            <Route exact path="/about" element={<AboutPage />} />
            <Route exact path="/why-marquis" element={<WhyMarquisPage />} />
            <Route exact path="/our-identity" element={<OurIdentityPage />} />
            <Route
              exact
              path="/investing-in-dubai"
              element={<InvestingPage />}
            />
            <Route exact path="/properties" element={<CollectionPage />} />
            <Route
              exact
              path="/properties/:slug"
              element={<CollectionInnerPage />}
            />
            <Route exact path="/leadership" element={<OurteamPage />} />
            <Route exact path="/media-news" element={<MediaPage />} />
            <Route exact path="/insights" element={<BlogPage />} />
            <Route exact path="/blog/:slug" element={<BlogInnerPage />} />
            <Route exact path="/events" element={<EventsPage />} />
            <Route
              exact
              path="/events/:slug"
              element={<EventsInnerPage />}
            />
            <Route exact path="/careers" element={<CareerPage />} />
            <Route
              exact
              path="/careers/:slug"
              element={<CareerInnerPage />}
            />
            <Route exact path="/contact" element={<ContactPage />} />
            <Route
              exact
              path="/partner-with-us"
              element={<BecomeAgentPage />}
            />
            <Route exact path="/our-communities" element={<CommunityPage />} />
            <Route
              exact
              path="/investor-relations"
              element={<InvestorPage />}
            />
            <Route exact path="/privacy-policy" element={<PrivacyPage />} />
            <Route
              exact
              path="/terms-conditions"
              element={<TermsConditionsPage />}
            />
            <Route exact path="/404-page" element={<NotFoundPage />} />
            <Route exact path="/awards" element={<AwardsPage />} />
            <Route exact path="/milestones" element={<MilestonePage />} />
            <Route
              exact
              path="/brochure-download"
              element={<BrochureDownload />}
            />
            <Route
              exact
              path="/constructions/:slug"
              element={<ConstructionPage />}
            />
            <Route
              exact
              path="/communities-inner/:slug"
              element={<CommunityInnerPage />}
            />
          </Route>
        </Routes>
      </Fragment>
    </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
